import { canonical } from "@/common/functions";

export default function() {
	let metaTags = [
		{
			name: "description",
			content: this.isError
				? this.$t("ErrorPageMetaDescription")
				: this.article.metaDescription,
		},
		{
			name: "og:title",
			content: this.article.metaTitle,
		},
		{
			name: "og:description",
			content: this.article.teaser || this.article.metaDescription,
		},
		{
			name: "og:image",
			content: this.article?.coverImage?.urlSmall || "",
		},
		{
			name: "og:url",
			content: canonical(this.$route).href,
		},
		{
			name: "og:type",
			content: "article",
		},
	];

	if (!this.isHideDate && this.entryPublishedTime) {
		metaTags.push({
			name: "article:published_time",
			content: this.entryPublishedTime,
		});
	}

	return {
		title: this.isError
			? this.$t("ErrorPageMetaTitle")
			: this.article.metaTitle,
		meta: metaTags,
		link: [canonical(this.$route)],
	};
}
